<template>
  <section id="eventlist" class="content">
    <!--no matching result-->
    <div
      class="accessory-list-default"
      v-show="isShowEmptyList"
    >
      <img
        src="../../../static/img/icon_no_matching_result.svg"
        class="center-block accessory-list-no-matching-img"
      >
      <div class="text-center col-sm-6 col-sm-offset-3">
        <h4 class="page-404-tips">No event found.</h4>
      </div>
    </div>
    <!--no matching result-->
    <div
      class="agent-list"
      v-bind:value="list"
      v-for="(item,index) in list"
    >
      <div class="row">
        <div class="col-lg-1 col-md-2 col-sm-2 col-xs-3">
          <img
            class="device-user-list-portrait"
            v-if="item.photo == ''"
            src="../../../static/img/img_device_user_default.png"
          >
          <img
            class="device-user-list-portrait"
            v-else
            v-bind:src="'https://d.din.bz/'+item.photo"
          >
        </div>
        <div
          class="col-lg-7 col-md-6 col-sm-10 col-xs-9 device-user-list-data"
        >
          <p class="device-user-list-username">{{item.user}}</p>
          <p
            class="device-user-list-devicename"
          >{{item.time | formatTime}}</p>
        </div>
        <div
          class="col-lg-4 col-md-4 col-sm-12 col-xs-12 btn-device-user-list"
        >
          <span
            class="pull-right"
          >{{item.cmdname | capitalize}}</span>
        </div>
      </div>
    </div>
  </section>
  <!-- /.content -->
</template>
<script>
import api from "../../api";
import utils from "../../utils";
import global from "../Global.vue";

export default {
  name: "EventList",
  data() {
    return {
      list: []
    };
  },
  computed: {
    isShowEmptyList() {
      return this.list.length < 1;
    }
  },
  filters: {
    formatTime(time) {
      return utils.formatDate(new Date(time / 1000000), "yyyy-MM-dd hh:mm:ss");
    },
    capitalize(cmdname) {
      return utils.capitalize(cmdname);
    }
  },
  methods: {
    async fetchEventList() {
      var params = new URLSearchParams();
      var time = this.list.length
        ? this.list[this.list.length - 1].time
        : Date.now() * 1000000;
      var jsons = {
        appid: this.$route.query.appid,
        deviceid: this.$route.query.deviceid,
        devicename: this.$route.query.devicename,
        time
      };
      params.append(
        "json",
        utils.getRC4Hex(JSON.stringify(jsons), global.APP_SECRET)
      );
      if (window.localStorage) {
        params.append("token", this.$router.app.$store.state.user.token);
      }
      const response = await api.request(
        "post",
        "/getdeviceeventlistdata?_type=json",
        params
      );
      if (response) {
        var { data } = response;
        var { Result } = data;
        if (Result) {
          var list = JSON.parse(
            utils.getDecodeRC4Hex(Result, global.APP_SECRET)
          );
          this.list.push(...list.filter(item => +item.result));
        }
      }
    },
    handleScroll(e) {
      var jqueryWindow = window.jQuery(window);
      var listNodeHeight = window.jQuery("#eventlist").height();
      var windowScrollTop = jqueryWindow.scrollTop();
      var windowHeight = jqueryWindow.height();
      if (
        this.currentDeviceListHeight < listNodeHeight &&
        windowScrollTop + windowHeight >= listNodeHeight
      ) {
        this.currentDeviceListHeight = windowScrollTop + windowHeight;
        this.fetchEventList();
      }
    }
  },
  async mounted() {
    var params = new URLSearchParams();
    var { query } = this.$route;
    var { appid, deviceid } = query;
    var jsons = { appid, deviceid };
    params.append(
      "json",
      utils.getRC4Hex(JSON.stringify(jsons), global.APP_SECRET)
    );
    if (window.localStorage) {
      params.append("token", this.$router.app.$store.state.user.token);
    }
    this.$store.commit("TOGGLE_FULLSCREEN_LOADING");
    await this.fetchEventList(params);
    this.$store.commit("TOGGLE_FULLSCREEN_LOADING");
    this.currentDeviceListHeight = 0;
    window.addEventListener("scroll", this.handleScroll, false);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll, false);
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// EventList.vue?362d16c4